export const indicesInWarmTier = (validationState) => {
  var _a, _b;
  return (_b = (_a = validationState == null ? void 0 : validationState.context) == null ? void 0 : _a.searched_index_ranges) == null ? void 0 : _b.filter((range) => range.is_warm_tiered);
};
export const isSearchingWarmTier = (warmTierRanges) => (warmTierRanges == null ? void 0 : warmTierRanges.length) > 0;
